// extracted by css-extract-rspack-plugin
export default {"wrapper":"mluYNhhY3LwTJ3vz"};